import type { Doc } from "../../_generated/dataModel";
import type { FilterRule, FilterRuleCtx } from "../../lib/types/filters_types";

/** Filtra órdenes de compra por estado sin perder el aislamiento empresa/sucursal. */
export const purchaseOrderStatusRule: FilterRule<Doc<"purchase_orders">> = {
  priority: 2,
  build: async (ctx: FilterRuleCtx, args) => {
    const status = (
      args as Partial<Doc<"purchase_orders">> & { status?: string }
    ).status;

    if (!status) return undefined;

    const rows = await ctx.db
      .query("purchase_orders")
      .withIndex("by_company_and_status", (q) =>
        q
          .eq("internalControl.companyId", ctx.userContext.companyId)
          .eq("status", status as Doc<"purchase_orders">["status"]),
      )
      .collect();

    const branchId = ctx.userContext.branchId;
    return branchId
      ? rows.filter((row) => row.internalControl.branchId === branchId)
      : rows;
  },
};
